import { datadogLogs } from '@datadog/browser-logs';

import type { LoggerContext, LoggerInterface } from '@/utils/logging/_types';

export function DatadogLogger(): LoggerInterface {
  const info = (message: string, context?: LoggerContext) => {
    datadogLogs.logger.info(message, context);
  };

  const debug = (message: string, context?: LoggerContext) => {
    datadogLogs.logger.debug(message, context);
  };

  const warn = (message: string, context?: LoggerContext) => {
    datadogLogs.logger.warn(message, context);
  };

  const error = (message: string, context?: LoggerContext) => {
    datadogLogs.logger.error(message, context);
  };

  return Object.freeze({
    info,
    debug,
    warn,
    error,
  });
}
